<template>
    <div class="no-auth">
        <h2>您暂无该页面的权限</h2>
        <h3>如需获取权限，请联系贵司主账号{{ accountDetail }}操作分配权限。</h3>
    </div>
</template>

<script>
export default {
    data() {
        return {
            account: '',
            phone: '',
        };
    },
    computed: {
        accountDetail() {
            if (this.account && this.phone) {
                return `（账号：${this.account}，手机号：${this.phone}）`;
            } else if (this.account) {
                return `（账号：${this.account}）`;
            } else if (this.phone) {
                return `（手机号：${this.phone}）`;
            } else {
                return '';
            }
        },
    },
    async created() {
        const res = await this.$hPost('/api/vss/shepherd/supplier/account/mainAccount');
        if (res && res.supplierBizAccount) {
            this.account = res.supplierBizAccount.login;
            this.phone = res.supplierBizAccount.phone;
        }
    },
};
</script>

<style lang="scss" scoped>
.no-auth {
    margin-top: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
